import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './commonUI/home/home.component';
import { ProposalComponent } from './proposal/crud/proposal.component';
import { ProposallistComponent } from './proposallist/proposallist.component';
import { PendingproposallistComponent } from './proposal/lists/pendingproposallist/pendingproposallist.component';
import { ExemptedPartsListComponent } from './proposal/pe/exemptedpartslist/exemptedparts-list.component';
import { PackageLevelTemplateComponent } from './packagelevel-template/packagelevel-template.component';
import { AuthGuard } from '@tesla/ng-auth';
import { ReviewproposallistComponent } from './proposal/lists/reivewproposallist/reivewproposallist.component';
import { UnreadcommentslistComponent } from './proposal/lists/unreadcommentslist/unreadcommentslist.component';
import { PackageLevelTemplateListComponent } from './packagelevel-template/lists/packagelevel-template-list.component';
import { PartlisthotrequestComponent } from './parts/partlisthotrequest/partlisthotrequest.component';
import { PeCreateproposalComponent } from './proposal/pe/pe-createproposal/pe-createproposal.component';
import { ProposalSnapshotComponent } from './proposal/pe/proposal-snapshot/proposal-snapshot.component';
import { RejectedProposalListComponent } from './proposal/lists/rejected-proposal-list/rejected-proposal-list.component';
import { PeAssignmentComponent } from './pe/pe-assignment/pe-assignment.component';
import { ViewProposalComponent } from './proposal/view-proposal/view-proposal.component';
import { SavedProposalsComponent } from './proposal/lists/saved-proposals/saved-proposals.component';
import { SearchPartComponent } from './parts/search-part/search-part.component';
import { CriticalPartsComponent } from './parts/critical-part/critical-part.component';
import { AdminRoleGuard } from './auth/guards/admin.role.guard';
import { UnSavedGuard } from './commonUI/guards/unsaved.guard';
import { SearchPartPeComponent } from './proposal/pe/search-part-pe/search-part-pe.component';
import { EmployeeRoleGuard } from './auth/guards/employee.role.guard';
import { PackagelevelTemplateViewComponent } from './packagelevel-template/packagelevel-template-view/packagelevel-template-view.component';
import { AppRoutes } from './utils/approutes';
import { UserPermissions } from './permissions';
import { landingpageComponent } from './commonUI/landingpage/landingpage.component';
import { PendinginspectionproposallistComponent } from './proposal/lists/pendinginspectionproposallist/pendinginspectionproposallist.component';
import { AdhocrequestComponent } from './proposal/pe/adhocrequest/adhocrequest.component';
import { PeAddsourcetypeComponent } from './proposal/pe/pe-addsourcetype/pe-addsourcetype.component';
import { PeBulkuploadComponent } from './proposal/pe/pe-bulkupload/pe-bulkupload.component';
import { ApprovedProposalListComponent } from './proposal/lists/approved-proposal-list/approved-proposal-list.component';
import { IncompleteProposalListComponent } from './proposal/lists/incomplete-proposal-list/incomplete-proposal-list.component';
import { SubmittedProposalListComponent } from './proposal/lists/submitted-proposal-list/submitted-proposal-list.component';
import { AddNewAssignmentComponent } from './pe/pe-assignment/add-new-assignment/add-new-assignment.component';
import { PeBulkcopyComponent } from './proposal/pe/pe-bulkcopy/pe-bulkcopy.component';
import { PeAdhocduedateExtensionRequestDashboardComponent } from './proposal/pe/pe-adhocduedate-extension-request-dashboard/pe-adhocduedate-extension-request-dashboard.component';
import { PeSyncproposalComponent } from './proposal/pe/pe-syncproposal/pe-syncproposal.component';
import { PackageEngineerAssignmentComponent } from './pe/package-engineer-assignment/package-engineer-assignment.component';
import { PeAddpackageengineerComponent } from './proposal/pe/pe-addpackageengineer/pe-addpackageengineer.component';
import { PeBulkpackagetemplateComponent } from './proposal/pe/pe-bulkpackagetemplate/pe-bulkpackagetemplate.component';
import { AdminInfoButtonsComponent } from './admin/admin-info-buttons/admin-info-buttons.component';
import { TPMEstimateRequestComponent } from './estimates/tpm/tpm-bulk-estimate-request/tpm-bulk-estimate-request.component';
import { EstimateRequestListTpmComponent } from './estimates/tpm/estimate-request-list-tpm/estimate-request-list-tpm.component';
import { BulkuploadestimatesComponent } from './estimates/pe/pe-bulk-upload-estimates/pe-bulk-upload-estimates.component';
import { EstimaterequestlistPEComponent } from './estimates/pe/estimate-request-list-pe/estimate-request-list-pe.component';
import { PeViewEstimteComponent } from './estimates/pe/pe-view-estimate/pe-view-estimate.component';
import { TpmReviewEstimateComponent } from './estimates/tpm/tpm-review-estimate/tpm-review-estimate.component';
const routes: AppRoutes = [
    // {
    //    path: 'auth',
    //    data: {
    //        breadcrumb: 'Authentication',
    //    },
    //    loadChildren: './auth/auth.module#AuthModule',
    // },
    {
        path: '',
        redirectTo: 'landingpage',
        pathMatch: 'full',
    },
    {
        path: 'landingpage',
        component: landingpageComponent,
        data: {
            breadcrumb: '',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'home',
        component: HomeComponent,
        data: {
            breadcrumb: '',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'proposal/:id',
        component: ProposalComponent,
        data: {
            breadcrumb: 'Update Proposal',
        },
        canActivate: [AuthGuard],
        canDeactivate: [UnSavedGuard],
    },
    {
        path: 'proposal',
        component: ProposalComponent,
        data: {
            breadcrumb: 'Create Proposal',
        },
        canActivate: [AuthGuard],
        canDeactivate: [UnSavedGuard],
    },
    {
        path: 'AdHocRequest',
        component: AdhocrequestComponent,
        data: {
            breadcrumb: 'Ad-hoc Request',
        },
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [
            UserPermissions.Packaging_ReviewProposal_Read,
            UserPermissions.Packaging_ReviewProposal_Write,
        ],
    },
    {
        path: 'CriticalParts',
        component: CriticalPartsComponent,
        data: {
            breadcrumb: 'Critical Parts',
        },
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [
            UserPermissions.Packaging_ReviewProposal_Read,
            UserPermissions.Packaging_ReviewProposal_Write,
        ],
    },
    {
        path: 'Pendingproposals',
        component: PendingproposallistComponent,
        data: {
            breadcrumb: 'Pending Proposals',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'UnreadComments',
        component: UnreadcommentslistComponent,
        data: {
            breadcrumb: 'Unread Comments',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'searchpart',
        component: SearchPartComponent,
        data: {
            breadcrumb: 'Search Part',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'Rejectedproposals',
        component: RejectedProposalListComponent,
        data: {
            breadcrumb: 'Rejected Proposals',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'proposallist',
        component: ProposallistComponent,
        data: {
            breadcrumb: 'Proposal List',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'packageleveltemplateList',
        component: PackageLevelTemplateListComponent,
        data: {
            breadcrumb: 'Package Templates',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'packageleveltemplate',
        component: PackageLevelTemplateComponent,
        data: {
            breadcrumb: 'Package Template',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'viewpackageleveltemplate/:id',
        component: PackagelevelTemplateViewComponent,
        data: {
            breadcrumb: 'View Package Template',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'packageleveltemplate/:id',
        component: PackageLevelTemplateComponent,
        data: {
            breadcrumb: 'Package Template',
        },
        canActivate: [AuthGuard],
        canDeactivate: [UnSavedGuard],
    },
    {
        path: 'Approvedproposals',
        component: ApprovedProposalListComponent,
        data: {
            breadcrumb: 'Approved Proposals',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'Incompleteproposals',
        component: IncompleteProposalListComponent,
        data: {
            breadcrumb: 'Incomplete Proposals',
        },
        canActivate: [AuthGuard],
    },
    {
        // TMS-17427 Add Submitted proposal view UI for suppliers
        path: 'Submittedproposals',
        component: SubmittedProposalListComponent,
        data: {
            breadcrumb: 'Submitted Proposals',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'Reviewproposals',
        component: ReviewproposallistComponent,
        data: {
            breadcrumb: 'Review Proposals',
        },
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [
            UserPermissions.Packaging_ReviewProposal_Read,
            UserPermissions.Packaging_ReviewProposal_Write,
        ],
    },
    {
        path: 'PendingInspectionProposals',
        component: PendinginspectionproposallistComponent,
        data: {
            breadcrumb: 'Pending Inspection',
        },
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [
            UserPermissions.Packaging_ReviewProposal_Read,
            UserPermissions.Packaging_ReviewProposal_Write,
        ],
    },
    {
        path: 'searchpartpe',
        component: SearchPartPeComponent,
        data: {
            breadcrumb: 'Search Part',
        },
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [
            UserPermissions.Packaging_SearchPart_Read,
            UserPermissions.Packaging_SearchPart_Write,
        ],
    },
    {
        path: 'pe-createproposal',
        component: PeCreateproposalComponent,
        data: {
            breadcrumb: 'Tesla-Create proposal',
        },
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [
            UserPermissions.Packaging_CreateProposal_Read,
            UserPermissions.Packaging_CreateProposal_Write,
        ],
    },
    {
        path: 'pe-proposalsnapshot/:id',
        component: ProposalSnapshotComponent,
        data: {
            breadcrumb: 'Review proposal',
        },
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_ReviewProposal_Write],
    },
    {
        path: 'viewproposal/:id',
        component: ViewProposalComponent,
        data: {
            breadcrumb: 'View proposal',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'peassignment',
        //      component: PeAssignmentComponent,
        component: PackageEngineerAssignmentComponent,
        data: {
            breadcrumb: 'Package Engineer Assignment',
        },
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [
            UserPermissions.Packaging_PackageEngineerAssignment_Read,
            UserPermissions.Packaging_PackageEngineerAssignment_Write,
        ],
    },
    {
        path: 'pe-add-assignment',
        component: AddNewAssignmentComponent,
        data: {
            breadcrumb: 'Add New Assignment',
        },
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [
            UserPermissions.Packaging_PackageEngineerAssignment_Read,
            UserPermissions.Packaging_PackageEngineerAssignment_Write,
        ],
    },
    {
        path: 'saved-proposals',
        component: SavedProposalsComponent,
        data: {
            breadcrumb: 'Proposals just saved',
        },
        canActivate: [AuthGuard],
    },
    {
        path: 'exemptedpartslist',
        component: ExemptedPartsListComponent,
        data: {
            breadcrumb: 'Exempt Parts',
        },
        canActivate: [AuthGuard, EmployeeRoleGuard],
        canDeactivate: [UnSavedGuard],
        Roles: [
            UserPermissions.Packaging_ReviewProposal_Read,
            UserPermissions.Packaging_ReviewProposal_Write,
        ],
    },
    {
        path: 'addsourcetype',
        component: PeAddsourcetypeComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [
            UserPermissions.Packaging_SourceType_Read,
            UserPermissions.Packaging_SourceType_Write,
        ],
    },
    {
        path: 'bulkupload',
        component: PeBulkuploadComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_CreateProposal_Write],
    },
    {
        path: 'bulkcopyproposals',
        component: PeBulkcopyComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_CreateProposal_Write],
    },
    {
        path: 'adhocdueDateRequestDashboard',
        component: PeAdhocduedateExtensionRequestDashboardComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_ReviewProposal_Write],
    },
    {
        path: 'syncproposal',
        component: PeSyncproposalComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_CreateProposal_Write],
    },
    {
        path: 'addpackageengineer',
        component: PeAddpackageengineerComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [
            UserPermissions.Packaging_SourceType_Read,
            UserPermissions.Packaging_SourceType_Write,
        ],
    },
    {
        path: 'pebulkuploadpackagetemplate',
        component: PeBulkpackagetemplateComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_CreateProposal_Write],
    },
    {
        path: 'admininfobuttons',
        component: AdminInfoButtonsComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_PackageEngineerAssignment_Write],
    },
    {
        path: 'estimaterequestpelist',
        component: EstimaterequestlistPEComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_CreateProposal_Write],
    },
    {
        path: 'estimaterequesttpmlist',
        component: EstimateRequestListTpmComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_PackageEngineerAssignment_Write],
    },
    {
        path: 'bulkuploadestimaterequests',
        component: TPMEstimateRequestComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_PackageEngineerAssignment_Write],
    },
    {
        path: 'bulkuploadestimates',
        component: BulkuploadestimatesComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_CreateProposal_Write],
    },
    {
        path: 'pe-viewestimate/:id',
        component: PeViewEstimteComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_CreateProposal_Write],
    },
    {
        path: 'tpm-reviewestimate/:id',
        component: TpmReviewEstimateComponent,
        canActivate: [AuthGuard, EmployeeRoleGuard],
        Roles: [UserPermissions.Packaging_PackageEngineerAssignment_Write],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
